/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import isEqual from "@/app/utils/isEqual";
import dataStore from '@/app/store/register';
import events from '@/app/store/events';
// Init data func
const dataStoreFunc = {};
// eslint-disable-next-line camelcase

const store = {
  /**
   * Hàm set dữ liệu vào store theo key
   * @param key khóa dữ liệu trong store
   * @param value giá trị mới
   */
  setValue(key: string, value: any): undefined {
    /**
     * Hàm trigger đến toàn bộ funcion khi một key thay đổi
     * @param key khóa dữ liệu trong store
     * @param value giá trị trong store
     */
    const updateAllFunc = (key: string, value: any) => {
      const functions = Object(dataStoreFunc)[key] || [];
      for (let i = 0; i < functions.length; i++) {
        const func = functions[i];
        func(value);
      }
    };

    // Update value in store
    if (dataStore) {
      // const currentVal = Object(dataStore)[key];
      // if (!isEqual(currentVal, value)) {
      Object(dataStore)[key] = value;
      updateAllFunc(key, value);
      // }
    }
    return;
  },
  /**
   * Hàm lấy dữ liệu từ store theo key
   * @param key khóa dữ liệu trong store
   * @returns trả về dữ liệu trong key
   */
  getValue(key: string): any | undefined {
    if (dataStore) {
      return Object(dataStore)[key];
    }
    return;
  },
  /**
   * Hàm lắng nghe một key nào đó thay đổi
   * @param key khóa dữ liệu trong store
   * @param func function callback
   */
  onChange(key: string, func: (value: any) => void): undefined {
    Object(dataStoreFunc)[key] = Object(dataStoreFunc)[key] || [];
    Object(dataStoreFunc)[key].push(func);
    return;
  },

  /**
   * unset
   * @param key ..
   */
  unset(key: string): undefined {
    if (Object(dataStoreFunc)[key]) {
      Object(dataStoreFunc)[key] = [];
      delete Object(dataStoreFunc)[key];
    }
    return;
  },

  events: events,
};

export default store;
